import {getApi} from '../../modules/common/utils/api'
import _ from 'lodash'
const api = getApi('default')

export function getEntityObjects(entityID, params) {
  return api.get(`/v2/entities/${entityID}/objects`, !_.isEmpty(params) && {params: params})
}
// ticket-id: https://teamassetpanda.atlassian.net/browse/IN-432
// Date of commenting reservation code: 10th May, 2022.
// Reason: Need more clarification on reservation for jira creation from product team.
// Requested By:- Requested by the product team(Adam).
// export function getTicketEntityObjectValues(object_id) {
//   return api.get(`v3/fields/integrate_entity_object/${object_id}`)
// }

// export function getTicketData({object_id, uid}) {
//   return api.get(`v3/fields/ticket_data/${object_id}/reservation_item/${uid}?integration_key=jira_itsm`)
// }

// export function getTicketFieldValues(project_key, parent_key) {
//   return api.get(`v3/fields/integration_field_values?integration_key=jira_itsm&project_key=${project_key}&parent_key=${parent_key}`)
// }

export function getReservedForFieldValues(fieldIds, fieldType, search) {
  let fields = fieldIds.join(',')
  return api.get(
    `v3/fields/reserve_field_values?field_ids=${fields}&field_type=${fieldType}&query=${search}&limit=50&page=1&parent_child_relation=true`,
    {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
      },
    }
  )
}
